var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];
var gptAdSlots = gptAdSlots || [];
var gptAdSlotsDefined = [];
var adId = aisleUrl != null ? aisleUrl : 'ResultatsRecherche';
var siteContext = "Ecom";
var resizeTimer;
let adPosition = 0;

function createCatalogAds() {
    injectGoogleTagScriptForAds();

    googletag.cmd.push(function () {
        var mappingLargeAds = googletag.sizeMapping()
            .addSize([1200, 0], [970, 90])
            .addSize([980, 0], [728, 90])
            .addSize([730, 0], [468, 60])
            .addSize([0, 0], [[320, 100], [320, 50], [234, 60]])
            .build();

        var mappingSmallAds = googletag.sizeMapping()
            .addSize([1200, 0], [468, 60])
            .addSize([980, 0], [468, 60])
            .addSize([730, 0], [468, 60])
            .addSize([0, 0], [[320, 100], [320, 50], [234, 60]])
            .build();

        defineAdSlot(adPos1DesktopIdentifier, 'POS1', mappingLargeAds, [[970, 90], [728, 90], [468, 60], [320, 100], [320, 50], [234, 60]]);
        defineAdSlot(adPos2DesktopIdentifier, 'POS2', mappingLargeAds, [[970, 90], [728, 90], [468, 60], [320, 100], [320, 50], [234, 60]]);
        defineAdSlot(adPos2TabletIdentifier, 'POS2', mappingLargeAds, [[970, 90], [728, 90], [468, 60], [320, 100], [320, 50], [234, 60]]);
        defineAdSlot(adPos2MobileIdentifier, 'POS2', mappingSmallAds, [[468, 60], [320, 100], [320, 50], [234, 60]]);

        googletag.pubads().collapseEmptyDivs();
        googletag.enableServices();
    });

    window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(refreshCatalogAds, 250);
    });
}

function refreshCatalogAds() {
    displayCatalogAds(true);
}

function displayCatalogAds(refresh) {
    displayCatalogAd(adPos1DesktopIdentifier, true, refresh);
    displayCatalogAd(adPos2DesktopIdentifier, false, refresh);
    displayCatalogAd(adPos2TabletIdentifier, false, refresh);
    displayCatalogAd(adPos2MobileIdentifier, false, refresh);
}

function displayCatalogAd(blockId, forceDisplay, refresh) {
    var $ad = $('#' + blockId);
    if ($ad.length > 0 && (forceDisplay || $ad.is(':visible'))) {
        googletag.cmd.push(function () {
            googletag.display(blockId);
            if (refresh) {
                googletag.pubads().refresh([gptAdSlots[gptAdSlotsDefined[blockId]]]);
            }
        });
    }
}

function defineAdSlot(adIdentifier, positionId, sizeMapping, adDimensions) {
    if (typeof adIdentifier !== 'undefined' && adIdentifier !== '' && $('#' + adIdentifier).length > 0) {
        let adUnitPath = '/' + googleTagKey + '/' + lang + '-' + province + '-Metro-' + siteContext + '-' + adId + '-' + positionId;

        gptAdSlots[adPosition] = googletag.defineSlot(adUnitPath, adDimensions, adIdentifier)
            .defineSizeMapping(sizeMapping)
            .addService(googletag.pubads());
        gptAdSlotsDefined[adIdentifier] = adPosition;
        adPosition++;
    }
}

$(document).ready(function () {
    // Only if Storetail does not display any ads
    if (!window.__sto || !window.__sto.adsToDisplay) {
        createCatalogAds();
        displayCatalogAds(false);
    }
});